import { FormGroup } from "@angular/forms";
import { SalesReportRequest } from "../models/common-data-types";
import { formatDate } from "./date-validators";

export function mapToSalesReport(form: FormGroup): SalesReportRequest{
    const formValue = form.getRawValue();

    return {
        startDate: formatDate(formValue.startDate),
        endDate: formatDate(formValue.endDate),
        orderStatus: formValue.orderStatus,
        customerType: formValue.customerType
    };
}